import { Add } from "@mui/icons-material";
import { makeStyles } from "tss-react/mui";

import { Box, Button, Toolbar, Typography } from "@mui/material";
import Table from "../../components/PersistentList/GrapeListTable";

import { ToastContainer } from "react-toastify";

import { useNavigate } from "react-router-dom";

const useStyles = makeStyles()((theme) => ({
	title: {
		flexGrow: 1,
		display: "none",
		[theme.breakpoints.up("sm")]: {
			display: "block",
		},
	},
}));

export const PersistentList = ({ searchText }) => {
	const { classes } = useStyles();
	const navigate = useNavigate();

	return (
		<Box p={2}>
			<Toolbar>
				<Typography className={classes.title} variant="h4" noWrap>
					Persistent List
				</Typography>
				{/* <Button
					onClick={refreshHandler}
					startIcon={<LoopSharpIcon />}
					variant="contained"
					color="primary"
					sx={{
						marginRight:2
					}}
				>
					Refresh Persistent Lists 
				</Button> */}
				<Button
					onClick={() => {
						navigate("/w86zjruk6q/persistent-list/add");
					}}
					startIcon={<Add />}
					variant="contained"
					color="primary"
				>
					Add List
				</Button>
			</Toolbar>
			<ToastContainer />
			<Box sx={{ px: 5 }}>
				<Table />
			</Box>
		</Box>
	);
};
